'use strict';

var ServiceDemandClassFilterFactory = function ServiceDemandClassFilterFactory(DataFilter) {
  function ServiceDemandClassFilter() {
    DataFilter.call(this, 'service', 'class');
  }
  ServiceDemandClassFilter.constructor = ServiceDemandClassFilter;
  ServiceDemandClassFilter.prototype = Object.create(DataFilter.prototype);
  ServiceDemandClassFilter.prototype.groupBy = 'className';
  return ServiceDemandClassFilter;
};
ServiceDemandClassFilterFactory.$inject = ['DataFilterFactory'];
module.exports = ServiceDemandClassFilterFactory;